module.exports = __webpack_public_path__ + "img/promise.c9392232.png";